export default {"src":"/_next/static/media/olist.6790c44b.svg","height":195,"width":411};